loadjs.ready('js_default', function () {
    $(document).ready(function () {
        new News();
        new MBWG();
        new Nav();
        new HorGallery();

        $('select').each(function(index) {
            // Hinzufügen des data-atr Attributs mit einem Wert, der die Zeilennummer enthält
            NiceSelect.bind($(this)[0], {searchable: true, placeholder: 'select', searchtext: 'zoek', selectedtext: 'geselecteerd'});

        });


    });


});
